import React from "react";

import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import WPPaginaDAO from "./dataAccess/WP/WPPaginaDAO";
import WPFaqModel from "./model/WPFaqModel";
import Carregando from "./components/Carregando";
import NavegadorUtil from "./util/NavegadorUtil";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Rodape from "./components/Rodape";
import { ReactComponent as LogoFaleConosco } from "./assets/images/icons/fale-com-a-gente.svg";

interface IAjudaProps extends RouteComponentProps {}

type AjudaState = {
  busca: string;
  selecionado: string;
  carregando: boolean;
  concluido: boolean;
  faq: WPFaqModel[];
};

class Ajuda extends React.Component<IAjudaProps, AjudaState> {
  constructor(props: IAjudaProps) {
    super(props);

    this.filtrarFAQ = this.filtrarFAQ.bind(this);

    this.state = {
      busca: "",
      carregando: false,
      concluido: false,
      faq: [],
      selecionado: "",
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Ajuda");

    this.setState({ carregando: true });

    WPPaginaDAO.getInstance()
      .getFAQ()
      .then((faq: WPFaqModel[]) => {
        this.setState({ carregando: false, concluido: true, faq });
      });
  }

  filtrarFAQ(q: string): void {
    this.setState({ busca: q });
  }

  setSelecionado(i: string): void {
    this.setState({ selecionado: this.state.selecionado === i ? "" : i });
  }

  isSelecionado(i: string): any {
    return this.state.selecionado === i;
  }

  render(): any {
    const { busca, carregando, concluido } = this.state;
    let { faq } = this.state;
    let faqFiltrado: WPFaqModel[] = faq;
    let grupoAnterior: string = "";

    if (busca.length > 0) {
      faqFiltrado = faq
        .filter(
          (f) =>
            f.pergunta.toLowerCase().indexOf(busca.toLowerCase()) >= 0 ||
            f.resposta.toLowerCase().indexOf(busca.toLowerCase()) >= 0
        )
        .sort((a, b) => {
          if (a.grupo < b.grupo) {
            return -1;
          }
          if (a.pergunta < b.pergunta) {
            return -1;
          }
          return 1;
        });
    }

    return (
      <section className="help">
        <div className="header">
          <BotaoVoltar titulo="Ajuda"></BotaoVoltar>
        </div>
        <ul className="arrow-list">
          <li
            className="contato"
            onClick={() =>
              NavegadorUtil.redirect("/ajuda/contato", this.props.history)
            }
          >
            <div>
              <LogoFaleConosco
                title="Fale com a gente"
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  width: 50,
                }}
              ></LogoFaleConosco>
              Fale com a gente
            </div>
            <div className="more">&gt;</div>
          </li>
          <li
            onClick={() =>
              NavegadorUtil.redirect("/ajuda/paginas", this.props.history)
            }
          >
            <div>Política, Termos e Regulamento</div>
            <div className="more">&gt;</div>
          </li>
        </ul>
        <div className="faq">
          <h2>Perguntas frequentes</h2>
          <div className="form">
            <input
              type="text"
              name="search"
              id="search"
              className="query"
              onChange={(e) => this.filtrarFAQ(e.target.value as string)}
              style={{ fontFamily: "Raleway, Arial, FontAwesome" }}
              placeholder="Busque por palavra-chave"
            />
            <i className="fas fa-search"></i>
          </div>
          {faqFiltrado.length > 0 && (
            <dl>
              {faqFiltrado.map((f: WPFaqModel) => {
                let grupoTitulo: any = <></>;
                if (f.grupo !== grupoAnterior) {
                  grupoAnterior = f.grupo;
                  grupoTitulo = <h3>{f.grupo}</h3>;
                }
                return (
                  <React.Fragment key={f.id}>
                    {grupoTitulo}
                    <dt
                      dangerouslySetInnerHTML={{ __html: f.pergunta }}
                      className="bullet"
                      onClick={() => this.setSelecionado(f.id)}
                    />
                    {!this.isSelecionado(f.id) && (
                      <i
                        className="bullet fas fa-chevron-down"
                        onClick={() => this.setSelecionado(f.id)}
                      ></i>
                    )}
                    {this.isSelecionado(f.id) && (
                      <i
                        className="bullet fas fa-chevron-up"
                        onClick={() => this.setSelecionado(f.id)}
                      ></i>
                    )}
                    {this.isSelecionado(f.id) && (
                      <dd dangerouslySetInnerHTML={{ __html: f.resposta }} />
                    )}
                  </React.Fragment>
                );
              })}
            </dl>
          )}
          {!carregando && faqFiltrado.length === 0 && (
            <div>
              <p style={{ marginTop: 20 }}>
                Nenhum item encontrado para este filtro.
              </p>
            </div>
          )}
        </div>
        <Carregando exibir={carregando} concluido={concluido} />
        <Rodape parent={this} ativo="Menu"></Rodape>
      </section>
    );
  }
}

export default withRouter(Ajuda);
